import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconList = t0 => {
  const $ = _c(11);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" d="M3.875 9.5a5.625 5.625 0 1 0 11.25 0 5.625 5.625 0 0 0-11.25 0M3.875 32a5.625 5.625 0 1 0 11.25 0 5.625 5.625 0 0 0-11.25 0M3.875 54.5a5.625 5.625 0 1 0 11.25 0 5.625 5.625 0 0 0-11.25 0" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M22.625 9.5h37.5M22.625 32h37.5M22.625 54.5h37.5" style={{
      stroke: "#fff",
      strokeOpacity: 1
    }} />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props || $[8] !== t1 || $[9] !== t2) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}{t4}</svg>;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
IconList.displayName = 'IconList';